import React from 'react';
import { graphql } from 'gatsby';
import SiteHeader from '../components/SiteHeader/SiteHeader';
import Container from '../components/Container/Container';
import ParagraphHeader from '../components/Paragraph/ParagraphHeader';
import Paragraph from '../components/Paragraph/Paragraph';
import { GatsbyImage } from 'gatsby-plugin-image';

const TapetyObiektowe = ({ data }) => {
  return (
    <>
      <SiteHeader
        image={data.file.childImageSharp.gatsbyImageData}
        text='Tapety obiektowe'
      />
      <Container padding='32px 16px' width='740px'>
        <ParagraphHeader>Tapety i okleiny obiektowe</ParagraphHeader>
        <Paragraph>
          Tapety i okleiny obiektowe, to rodzaj okładzin ściennych o
          zwiększonych parametrach odpornościowych. Są to opatrzone atestami,
          certyfikowane produkty odpowiadające normom obowiązującym w
          budownictwie użyteczności publicznej (hotele, ośrodki wypoczynkowe,
          biura, centra handlowe). Materiały te wykonane są z winylu na podłożu
          tkanym, lub flizelinowym. Często wymagają użycia specjalistycznej
          chemii montażowej.
        </Paragraph>
        <GatsbyImage
          image={data.wallpaperImage.childImageSharp.gatsbyImageData}
        />
      </Container>
    </>
  );
};

export const query = graphql`
  {
    file(name: { eq: "object-wallpapers" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, quality: 80)
      }
    }
    wallpaperImage: file(name: { eq: "wallpaper-object" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, quality: 80)
      }
    }
  }
`;

export default TapetyObiektowe;
